// extracted by mini-css-extract-plugin
export var actionText = "_o0-4";
export var container = "_o0-0";
export var leftSection = "_o0-1";
export var rightSection = "_o0-2";
export var settingsButton = "_o0-6";
export var settingsIcon = "_o0-7";
export var shortcut = "_o0-5";
export var shortcutGroup = "_o0-3";